
import Vue,{VueConstructor} from 'vue';

//コンポーネントの登録～NamespaceとVueにコンポーネントと登録します。フォルダ毎にアルファベット順に記載してください。
//common
import {ControlValidator, Validator} from './common/validator';
import type {IControl, IEditor, IDirectEditProvider} from './common/validator';
export {ControlValidator,Validator};
export type {IControl,IEditor,IDirectEditProvider};

//components
import AuditLog from './components/auditLog.vue';
import Badge from './components/badge.vue';
import BadgeUser from './components/badgeUser.vue';
import Button from './components/button.vue';
import Button2 from './components/button2.vue';
import Editor from './components/editor.vue';
import EditPanel from './components/editPanel.vue';
import FieldList from './components/fieldList.vue';
import GlobalMenu from './components/globalMenu.vue';
import GlobalMenuDropdown from './components/globalMenuDropdown.vue';
import GlobalMenuDropdownItem from './components/globalMenuDropdownItem.vue';
import GlobalMenuItem from './components/globalMenuItem.vue';
import Grid from './components/grid.vue';
import GridItem from './components/gridItem.vue';
import GripButton from './components/gripButton.vue';
import HelpContent from './components/helpContent.vue';
import Label from './components/label.vue';
import Layer from './components/layer.vue';
import ListDialog from './components/listDialog.vue';
import ListDialog2 from './components/listDialog2.vue';
import ListEditor from './components/listEditor.vue';
import ListFiles from './components/listFiles.vue';
import ListView from './components/listView.vue';
import ListViewMenu from './components/listViewMenu.vue';
import ListViewMenuBar from './components/listViewMenuBar.vue';
import MenuItem from './components/menuItem.vue';
import MessageList from './components/messageList.vue';
import Mfa from './components/mfa.vue';
import Modal from './components/modal.vue';
import Modal2 from './components/modal2.vue';
import PageLayout from './components/pageLayout.vue';
import PopupEditor from './components/popupEditor.vue';
import Search from './components/search.vue';
import SideBar from './components/sidebar.vue';
import SideBarGroup from './components/sidebarGroup.vue';
import SideBarItem from './components/sidebarItem.vue';
import SideBarMenuItem from './components/sidebarMenuItem.vue';
import Splitter from './components/splitter.vue';
import SplitButton from './components/splitButton.vue';
import SVG from './components/svg.vue';
import Tab from './components/tab.vue';
import Tooltip from './components/tooltip.vue';
import Topics from './components/topics.vue';
import UsageDialog from './components/usageDialog.vue';
import Workflow from './components/workflow.vue';
import WorkflowDialog from './components/workflowDialog.vue';
import PayJp from './components/payJp.vue';
import ReportTemplate from './vues/reportTemplate.vue';

Vue.component('b-modal', Modal2); //BootstrapVueのmodalをオーバーライド

Vue.component('AuditLog',AuditLog);
Vue.component('Badge',Badge);
Vue.component('BadgeUser',BadgeUser);
Vue.component('Button',Button);
Vue.component('Button2',Button2);
Vue.component('Editor',Editor);
Vue.component('EditPanel',EditPanel);
Vue.component('FieldList',FieldList);
Vue.component('GlobalMenu',GlobalMenu);
Vue.component('GlobalMenuDropdown',GlobalMenuDropdown);
Vue.component('GlobalMenuDropdownItem',GlobalMenuDropdownItem);
Vue.component('GlobalMenuItem',GlobalMenuItem);
Vue.component('Grid',Grid);
Vue.component('GridItem',GridItem);
Vue.component('GripButton',GripButton);
Vue.component('HelpContent',HelpContent);
Vue.component('Label',Label);
Vue.component('Layer',Layer);
Vue.component('ListDialog',ListDialog);
Vue.component('ListDialog2',ListDialog2);
Vue.component('ListEditor',ListEditor);
Vue.component('ListFiles',ListFiles);
Vue.component('ListView',ListView);
Vue.component('ListViewMenu',ListViewMenu);
Vue.component('ListViewMenuBar',ListViewMenuBar);
Vue.component('MenuItem',MenuItem);
Vue.component('MessageList',MessageList);
Vue.component('Mfa',Mfa);
Vue.component('Modal',Modal);
Vue.component('b-modal2',Modal2);
Vue.component('PageLayout',PageLayout);
Vue.component('PopupEditor',PopupEditor);
Vue.component('Search',Search);
Vue.component('SideBar',SideBar);
Vue.component('SideBarGroup',SideBarGroup);
Vue.component('SideBarItem',SideBarItem);
Vue.component('SideBarMenuItem',SideBarMenuItem);
Vue.component('Splitter',Splitter);
Vue.component('SplitButton',SplitButton);
Vue.component('SvgIcon',SVG);
Vue.component('Tab',Tab);
Vue.component('Tooltip',Tooltip);
Vue.component('Topics',Topics);
Vue.component('UsageDialog',UsageDialog);
Vue.component('Workflow',Workflow);
Vue.component('WorkflowDialog',WorkflowDialog);
Vue.component('PayJp',PayJp);
Vue.component('ReportTemplate',ReportTemplate);

export {AuditLog,Badge,BadgeUser,Button,Button2,Editor,EditPanel,FieldList,GlobalMenu,GlobalMenuDropdown,GlobalMenuDropdownItem,GlobalMenuItem,Grid,GridItem,GripButton,HelpContent,Label,Layer,ListDialog,ListDialog2,ListEditor,ListFiles, 
ListView,ListViewMenu,ListViewMenuBar,MenuItem,MessageList,Mfa,Modal,Modal2,PageLayout,PopupEditor,Search,SideBar,SideBarGroup,SideBarItem,SideBarMenuItem,Splitter,SplitButton,SVG,Tab,Tooltip,Topics,UsageDialog,Workflow,WorkflowDialog,PayJp,ReportTemplate};

//controls
import AutoComplete from './controls/autocomplete.vue';
import Calendar from './controls/calendar.vue';
import CheckBox from './controls/checkBox.vue';
import ComboBox from './controls/comboBox.vue';
import Control from './controls/control.vue';
import FilterBox from './controls/filterbox.vue';
import NumericBox from './controls/numericBox.vue';
import RadioButton from './controls/radioButton.vue';
import RowSequence from './controls/rowSequence.vue';
import TextBox from './controls/textbox.vue';
import TimePicker from './controls/timepicker.vue';
import SlideControl from './controls/slideControl.vue';

Vue.component('AutoComplete',AutoComplete);
Vue.component('Calendar',Calendar);
Vue.component('CheckBox',CheckBox);
Vue.component('ComboBox',ComboBox);
Vue.component('Control',Control);
Vue.component('FilterBox',FilterBox);
Vue.component('NumericBox',NumericBox);
Vue.component('RadioButton',RadioButton);
Vue.component('RowSequence',RowSequence);
Vue.component('TextBox',TextBox);
Vue.component('TimePicker',TimePicker);
Vue.component('SlideControl',SlideControl);

export {AutoComplete,Calendar,CheckBox,ComboBox,Control,FilterBox, NumericBox,RadioButton,RowSequence,TextBox,SlideControl};

//外部コンポーネント
import DatePicker from 'vuejs-datepicker';
Vue.component('datepicker',DatePicker);

import VueTimepicker from 'vue2-timepicker'
Vue.component('timepicker',VueTimepicker);
import 'vue2-timepicker/dist/VueTimepicker.css';

//QRコード
import QRCode from 'qrcode.vue';
Vue.component('qrcode-vue',QRCode);

//カスタムコンポーネントの登録〜ハンドラを登録
import {Api} from './common/api';
Vue.component1 = async (name:string, constructor: VueConstructor<Vue>) => {
    //認証が完了している必要がある
    const api = Vue.prototype.$api as Api;
    let template : any = null;
    await api.template(name).then(obj=>template = obj);

    if (template){
        var temp = constructor as any;
        temp.options = Object.assign({},temp.options, Vue.compile(template.template));  
        Vue.component(name,temp);
    } else {
        Vue.component(name,constructor);
    }
}

//カスタム可能なコンポーネントを登録します～カスタムコンポーネントを使用する場合はvue.config.jsのruntimeCompilerを有効化
// import MatterCard from '@/views/MatterCard.vue';
// Vue.component1('MatterCard',MatterCard);
// import TaskCard from '@/views/TaskCard.vue';
// Vue.component1('TaskCard',TaskCard);